import React, { useEffect, useState } from "react"
import { EnterpriseData } from "../../../interfaces/enterprise/enterpriseData"
import enterpriseApi from "../../../store/reducers/enterprise/enterpriseApi"
import SectionDetailsTest from "../SectionDetailsTest"
import SectionMedia from "../SectionMedia"
import SectionKnowUnits from "../SectionKnowUnits"


interface Props {
  enterprise: EnterpriseData
}

export default function NavInternEnterpriseTest({enterprise}:Props) {
  const [selectedSection, setSelectedSection] = useState(0)
  const { data, isLoading, isError, isSuccess } = enterpriseApi.useGetUnitsQuery(enterprise.Id)
  const [navsSection, setNavsSection] = useState(["Detalhes", "Galeria"])

  useEffect(() => {
    if(isSuccess){
      var list = navsSection
      list.push("Unidades")
      setNavsSection(list)
    }
  }, [isSuccess])

  useEffect(() => {
  }, [navsSection])

  return (
    <>
      <div className="flex container-responsive-view-mob border-b-1 border-gray-100">
        {navsSection.map((item, index) => {
          return (
            <button
              key={'btnViewMob' + index}
              className={
                'text-sm mt-2 lg:mt-auto lg:text-xl font-bold pb-2 w-[150px] max-w-full ' +
                (selectedSection == index
                  ? 'text-[#F15C00] border-b-2'
                  : 'text-[#000000A6] ')
              }
              onClick={() => setSelectedSection(index)}
            >
              {item}
            </button>
          )
        })}
      </div>
      {selectedSection == 0 && <SectionDetailsTest enterprise={enterprise} />}
      {selectedSection == 1 && <SectionMedia enterprise={enterprise} />}
      {selectedSection == 2 && isSuccess && data != undefined && <SectionKnowUnits enterprise={enterprise} units={data?.Data} />}
    </>
  )
}
